import {ETheme, EMenuIntro} from '@/constants/conf';
import {TranslateResult} from 'vue-i18n';


export interface IMainMenuItem {
    title?: TranslateResult;  // libellé dans le menu
    segment?: TranslateResult;  // segment d'url
    theme: ETheme; // theme de couleur de l'item
    pageTheme?: ETheme; // theme du logo + burger
    intro: EMenuIntro; // le type d'intro souhaitée pour l'apparition
    image?: string | IMainMenuItemI18N; // l'image de fond de litem (peut etre ajusté en fonction du marché)
    imageOffset?: string, // decalage  de l'image dans le menu : exemple : 20% center, 100px (correspond à la prop css background-position)
    imageBottom?: string, // force l'image à s'aligner en par le bas sur desktop
    imageScale?: string, // taille  de l'image dans le menu : exemple : 150%, cover (correspond à la prop css background-size)
    layout?: string, // couleur du layout placé sur l'image (correspond à la prop css background-color, utiliser rgba pour avoir une transparence)
    layoutImage?: string, // image ou dégradé placé sur l'image (correspond à la prop css background-image)
    layoutIndex?: string, // mettre l'index du layout pour l'avoir devant ou derrière l'image
    pageComponent: string | IMainMenuItemI18N; // nom du composant qui sera chargé sur la page  (peut etre ajusté en fonction du marché)
    wordsCount?: number; // nombre de mots dans l'article, permet de déterminer la durée de lecture
    color?: string; // couleur de fond du layout
    tag?: boolean; // ajout d'un tag avec un picto pour mettre en avant un thème par magazine
}

export interface IMainMenuItemI18N {
    [key: string]: any; // Add index signature
}


export const mainMenu: Array<IMainMenuItem> = [
    {
        theme: ETheme.DARK,
        intro: EMenuIntro.DEFAULT,
        image: {
            FR: 'Edito_Mathieu-Vedrenne_menu.jpg',
            UK: 'Edito_Mouhammed-Choukeir_menu.jpg',
            LU: 'Edito_Olivier-Lecler_menu.jpg',
            CH: 'Edito_Franck-Bonin_menu.jpg',
            MC: 'Edito_Nicolas-Feit_menu.jpg',
        },
        pageComponent: {
            FR: 'EditoFR',
            UK: 'EditoUK',
            CH: 'EditoCH',
            LU: 'EditoLU',
            MC: 'EditoMC',
        },
        imageOffset: 'center',
        color: 'white',
        wordsCount: 150
    },
    {
        pageComponent: 'Pioneer',
        theme: ETheme.DARK,
        intro: EMenuIntro.ARTICLE,
        image: 'Pioneer_cover.jpg',
        imageOffset: 'top center',
        color: '#ccd3ea',
        wordsCount: 1234,
        tag: true
    },
    {
        pageComponent: 'KeyReport',
        theme: ETheme.DARK,
        intro: EMenuIntro.ARTICLE,
        image: 'KeyReport_cover.jpg',
        imageOffset: 'center',
        imageBottom: 'true',
        color: 'white',
        wordsCount: 2867
    },
    {
        pageComponent: 'Back',
        theme: ETheme.DARK,
        intro: EMenuIntro.ARTICLE,
        imageOffset: 'center',
        image: 'Back_cover.jpg',
        color: 'white',
        wordsCount: 800
    },
    {
        pageComponent: 'Future',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.ARTICLE,
        image: 'Future_cover.jpg',
        imageOffset: 'center',
        color: '#63b1d1',
        wordsCount: 2125,
        tag: true
    },
    {
        pageComponent: 'Travel',
        theme: ETheme.DARK,
        intro: EMenuIntro.ARTICLE,
        image: 'Travel_cover.jpg',
        imageOffset: 'center top',
        color: '#f8dc9d',
        wordsCount: 1380
    },
    {
        pageComponent: 'Culture',
        theme: ETheme.DARK,
        intro: EMenuIntro.ARTICLE,
        imageOffset: 'center bottom',
        image: 'Culture_cover.jpg',
        color: '#deead7',
        wordsCount: 1600
    },
    {
        pageComponent: 'Sustainable',
        theme: ETheme.DARK,
        intro: EMenuIntro.DEFAULT,
        image: 'Sustainable_001_w.svg',
        imageOffset: 'center',
        imageBottom: 'true',
        color: 'white',
        wordsCount: 500
    },
    {
        pageComponent: 'TrendingNow',
        theme: ETheme.DARK,
        intro: EMenuIntro.ARTICLE,
        image: 'TrendingNow_cover.jpg',
        imageOffset: 'center',
        color: 'white',
        wordsCount: 1018
    },
    {
        pageComponent: 'Futurama',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.DEFAULT,
        imageOffset: 'center',
        image: 'Futurama_cover.jpg',
        color: '#b4aea2',
        wordsCount: 50,
        tag: true
    },
    {
        pageComponent: 'Legal',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.DEFAULT,
        image: 'credits.svg',
        color: "#444e5e"
    },
];
